__turbopack_context__.v({
  "alertsBar": "investor-alerts-bar-module-scss-module__rEB-sW__alertsBar",
  "alertsBarIn": "investor-alerts-bar-module-scss-module__rEB-sW__alertsBarIn",
  "alertsBarT": "investor-alerts-bar-module-scss-module__rEB-sW__alertsBarT",
});
